exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-4a7405bb] li{margin-bottom:0!important}.tag-item[data-v-4a7405bb]{border-bottom:2px solid transparent}.is-selected[data-v-4a7405bb]{border-bottom:5px solid var(--secondary);transition:.3s}", ""]);

// exports
